import React, { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Button, Column, Text } from 'Components/UI'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'
import { MEMBERSHIPS_CORPORATE } from 'Constants/Paths'

import { Container, Overflow } from './styles'

function ExploreCorporateMembershipSection() {
  const router = useRouter()

  const handleClick = useCallback(() => {
    router.push(MEMBERSHIPS_CORPORATE)
  }, [router])

  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container p={[64, 64, 64, 120]}>
          <Overflow />

          <Column
            alignCenter
            gap={[11, 11, 11, 12]}
            maxWidth={LANDING_CONTENT_WIDTH_PX}
          >
            <SubsectionTitle
              centered
              inverse
              maxWidth={1100}
              subtitle="It’s networking done the smart way."
              title="Explore the value of Corporate Membership"
            />

            <Text center inverse regular screen20>
              Get more out of your membership and be profiled across the
              network.
            </Text>

            <Button large onClick={handleClick}>
              Find Out How
            </Button>
          </Column>
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default ExploreCorporateMembershipSection
